import { IconProps } from './types';

export function FastForward03({ size, ...props }: IconProps) {
  return (
    <svg fill="none" height={size} viewBox="0 0 42 24" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M38.9063 10.7672C39.856 11.3155 39.856 12.6861 38.9063 13.2344L26.0866 20.6359C25.137 21.1842 23.9499 20.4988 23.9499 19.4023L23.9499 4.59932C23.9499 3.50281 25.137 2.81748 26.0866 3.36574L38.9063 10.7672Z"
        fill="currentColor"
      />
      <path
        d="M30.1153 10.7672C31.0649 11.3155 31.0649 12.6861 30.1153 13.2344L17.2956 20.6359C16.3459 21.1842 15.1589 20.4988 15.1589 19.4023L15.1589 4.59932C15.1589 3.50281 16.3459 2.81748 17.2956 3.36574L30.1153 10.7672Z"
        fill="currentColor"
      />
      <path
        d="M21.3243 10.7672C22.2739 11.3155 22.2739 12.6861 21.3243 13.2344L8.50455 20.6359C7.55493 21.1842 6.36792 20.4988 6.36792 19.4023L6.36792 4.59932C6.36792 3.50281 7.55493 2.81748 8.50454 3.36574L21.3243 10.7672Z"
        fill="currentColor"
      />
    </svg>
  );
}
